import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const CustomersService = {
  save: (
    name: string,
    _id?: string, 
    contact?: string,
    phone_number?: string,
    status?: boolean
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}customers`, { _id, account, name, contact, phone_number, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}customers/${account}`);
  },
  saveField: (
    customer: string,
    name: string,
    _id?: string,
    hectares?: string,
    status?: boolean
  ) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}customers/field`, { _id, customer, name, hectares, status });
  },
  fields: (customer: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT}customers/field/${customer}`);
  },
}